
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.203","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h14.203v30H0z"}})])]),_c('g',{attrs:{"data-name":"Repeat Grid 5"}},[_c('g',{attrs:{"data-name":"Group 318","clip-path":"url(#a)"}},[_c('g',{attrs:{"data-name":"Group 316"}},[_c('path',{attrs:{"data-name":"Path 562","d":"M1.607 7.909L6.33 2.451a1.02 1.02 0 011.542 0l4.724 5.458a1.021 1.021 0 01-.771 1.688H2.379a1.02 1.02 0 01-.772-1.688z","fill":"#707070"}})]),_c('g',{attrs:{"data-name":"Group 317"}},[_c('path',{attrs:{"data-name":"Path 563","d":"M12.596 14.064l-4.724 5.458a1.019 1.019 0 01-1.542 0l-4.723-5.458a1.02 1.02 0 01.771-1.687h9.446a1.02 1.02 0 01.772 1.687z","fill":"#707070"}})])])])])
          )
        }
      }
    